import { IconCloudCheck } from '@tabler/icons-react';
import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type ISyncButtonProps = IBasicButtonProps;

const DefaultProps: Partial<ISyncButtonProps> = {
  variant: 'filled',
  color: 'blue',
  leftSection: <IconCloudCheck size={20} />,
};

/** @registry Filled blue "Sync" button with a cloud-check icon. */
export const SyncButton = React.forwardRef<HTMLButtonElement, ISyncButtonProps>(
  ({ children = 'Sync', ...props }, ref) => {
    return (
      <BasicButton {...DefaultProps} {...props} ref={ref}>
        {children}
      </BasicButton>
    );
  },
);
SyncButton.displayName = 'SyncButton';
